import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core'
import { SbsCommonComponent } from './sbs-common.component'
import { SbsSharedModule } from './sbs-shared/shared.module'
import { SbsEnvironment } from './sbs-shared/models/sbs-environment'
import { GraphQLModule } from './sbs-shared/modules/graphql.module'
import { ActionApp } from '../generated/common/graphql'

@NgModule({
  declarations: [SbsCommonComponent],
  imports: [GraphQLModule],
  providers: [],
  exports: [SbsCommonComponent, SbsSharedModule],
})
export class SbsCommonModule {
  public static forRoot(environment: SbsEnvironment, actionApp: ActionApp): ModuleWithProviders<SbsCommonModule> {
    return {
      ngModule: SbsCommonModule,
      providers: [
        {
          provide: SBS_ENVIRONMENT,
          useValue: environment,
        },
        {
          provide: ACTION_APP,
          useValue: actionApp,
        },
      ],
    }
  }
}

export const SBS_ENVIRONMENT = new InjectionToken<SbsEnvironment>('env')
export const ACTION_APP = new InjectionToken<ActionApp>('actionApp')
